/* ==========================================================================
   NEBAI COSMETICS — Interacciones y animaciones
   IIFE, sin módulos ES, sin dependencias externas.
   ========================================================================== */
(function(){
  "use strict";

  function safe(fn, label){
    try{ fn(); }catch(err){ console.error("[Nebai] " + label + ":", err); }
  }

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------------------------------------------------------------- */
  /* Modo claro / oscuro                                                     */
  /* El atributo data-theme ya se fija en <head> (script anti-parpadeo);     */
  /* aquí sólo conectamos el botón y persistimos la preferencia.             */
  /* ---------------------------------------------------------------------- */
  function initThemeToggle(){
    var btn = document.getElementById("themeToggle");
    var root = document.documentElement;

    function isDark(){ return root.getAttribute("data-theme") === "dark"; }

    function updateButton(){
      if(!btn) return;
      var dark = isDark();
      var key = dark ? "common.themeToLight" : "common.themeToDark";
      var fallback = dark ? "Activar modo claro" : "Activar modo oscuro";
      var label = (window.NebaiI18n && window.NebaiI18n.t) ? window.NebaiI18n.t(key) : fallback;
      btn.setAttribute("aria-pressed", dark ? "true" : "false");
      btn.setAttribute("aria-label", label);
    }

    function applyTheme(theme, persist){
      root.setAttribute("data-theme", theme);
      if(persist){
        try{ window.localStorage.setItem("nebai_theme", theme); }catch(e){}
      }
      updateButton();
    }

    /* Habilita la transición de color sólo después del primer pintado,     */
    /* para que el tema inicial no "parpadee" con una animación.            */
    window.requestAnimationFrame(function(){
      window.requestAnimationFrame(function(){
        document.body.classList.add("theme-ready");
      });
    });

    updateButton();

    if(btn){
      btn.addEventListener("click", function(){
        applyTheme(isDark() ? "light" : "dark", true);
      });
    }

    /* Si el usuario no ha elegido manualmente, sigue la preferencia del SO */
    if(window.matchMedia){
      var mq = window.matchMedia("(prefers-color-scheme: dark)");
      var onChange = function(e){
        var stored = null;
        try{ stored = window.localStorage.getItem("nebai_theme"); }catch(err){}
        if(!stored) applyTheme(e.matches ? "dark" : "light", false);
      };
      if(mq.addEventListener) mq.addEventListener("change", onChange);
      else if(mq.addListener) mq.addListener(onChange);
    }

    document.addEventListener("nebai:langchange", updateButton);
  }

  /* ---------------------------------------------------------------------- */
  /* Header: transparente -> cristal al hacer scroll                        */
  /* ---------------------------------------------------------------------- */
  function initHeader(){
    var header = document.getElementById("siteHeader");
    if(!header) return;
    var ticking = false;
    function update(){
      header.classList.toggle("is-scrolled", window.scrollY > 30);
      ticking = false;
    }
    window.addEventListener("scroll", function(){
      if(!ticking){ window.requestAnimationFrame(update); ticking = true; }
    }, { passive:true });
    update();
  }

  /* ---------------------------------------------------------------------- */
  /* Menú móvil                                                              */
  /* ---------------------------------------------------------------------- */
  function initMobileMenu(){
    var toggle = document.getElementById("menuToggle");
    var menu = document.getElementById("mobileMenu");
    if(!toggle || !menu) return;

    function open(){
      menu.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    }
    function close(){
      menu.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }
    toggle.addEventListener("click", function(){
      menu.classList.contains("is-open") ? close() : open();
    });
    menu.querySelectorAll("a").forEach(function(a){
      a.addEventListener("click", close);
    });
    document.addEventListener("keydown", function(e){
      if(e.key === "Escape" && menu.classList.contains("is-open")) close();
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Búsqueda                                                                */
  /* ---------------------------------------------------------------------- */
  function initSearch(){
    var overlay = document.getElementById("searchOverlay");
    var openBtn = document.getElementById("searchToggle");
    var closeBtn = document.getElementById("searchClose");
    var input = document.getElementById("searchInput");
    var form = overlay ? overlay.querySelector("form") : null;
    var hint = document.getElementById("searchHint");
    var results = document.getElementById("searchResults");
    if(!overlay) return;

    /* Base relativa según la profundidad de la página (index.html vs productos/… o legal/…) */
    var logoLink = document.querySelector(".site-header .logo");
    var base = logoLink ? logoLink.getAttribute("href").replace("index.html", "") : "";

    var PRODUCTS = [
      { name:"Serum de Ácido Hialurónico", cat:"Rostro · Hidratación", price:"14,95 €", url:"/products/serum-acido-hialuronico", img:(window.__NEBAI_ASSETS__ || "") + "serum-hero.jpg", kw:"serum hialuronico acido hidratacion rostro niacinamida" },
      { name:"Eye Patches", cat:"Contorno de ojos", price:"15,95 €", url:"/products/eye-patches", img:(window.__NEBAI_ASSETS__ || "") + "eye-patches-hero.jpg", kw:"eye patches ojos ojeras contorno mirada parches" },
      { name:"Pimple Patches", cat:"Tratamiento localizado", price:"12,25 €", url:"/products/pimple-patches", img:(window.__NEBAI_ASSETS__ || "") + "pimple-patches-hero.jpg", kw:"pimple patches granos acne imperfecciones parches" },
      { name:"Lip Patches", cat:"Labios", price:"14,99 €", url:"/products/lip-patches", img:(window.__NEBAI_ASSETS__ || "") + "lip-patches-hero.jpg", kw:"lip patches labios boca mascarilla hidratante" }
    ];

    function normalize(str){
      return (str || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
    }

    function findMatches(query){
      var q = normalize(query);
      if(!q) return [];
      return PRODUCTS.filter(function(p){
        return normalize(p.name + " " + p.cat + " " + p.kw).indexOf(q) !== -1;
      });
    }

    function renderResults(query){
      if(!results) return;
      var trimmed = query.trim();
      if(!trimmed){
        results.hidden = true;
        results.innerHTML = "";
        if(hint) hint.hidden = false;
        return;
      }
      if(hint) hint.hidden = true;
      var matches = findMatches(trimmed);
      if(!matches.length){
        var msg = (window.NebaiI18n && window.NebaiI18n.t)
          ? window.NebaiI18n.t("common.searchNoResults", { query: trimmed })
          : 'No se han encontrado resultados para "' + trimmed + '".';
        results.innerHTML = '<p class="search-empty"></p>';
        results.querySelector(".search-empty").textContent = msg;
        results.hidden = false;
        return;
      }
      results.innerHTML = matches.map(function(p){
        return '<a class="search-result" href="' + p.url + '">' +
          '<img src="' + p.img + '" alt="" loading="lazy">' +
          '<span class="search-result-info"><strong>' + p.name + "</strong><span>" + p.cat + " · " + p.price + "</span></span>" +
        "</a>";
      }).join("");
      results.hidden = false;
    }

    function open(){
      overlay.classList.add("is-open");
      window.setTimeout(function(){ if(input) input.focus(); }, 250);
    }
    function close(){
      overlay.classList.remove("is-open");
      if(input) input.value = "";
      renderResults("");
    }

    if(openBtn) openBtn.addEventListener("click", open);
    if(closeBtn) closeBtn.addEventListener("click", close);
    overlay.addEventListener("click", function(e){
      if(e.target === overlay) close();
    });
    document.addEventListener("keydown", function(e){
      if(e.key === "Escape" && overlay.classList.contains("is-open")) close();
    });

    if(input){
      input.addEventListener("input", function(){ renderResults(input.value); });
    }
    if(form){
      form.addEventListener("submit", function(e){
        e.preventDefault();
        var matches = findMatches(input ? input.value : "");
        if(matches.length) window.location.href = matches[0].url;
      });
    }
  }

  /* ---------------------------------------------------------------------- */
  /* Aparición progresiva al hacer scroll (con red de seguridad)            */
  /* ---------------------------------------------------------------------- */
  function initReveal(){
    var els = document.querySelectorAll(".reveal");
    if(!els.length) return;

    if(!("IntersectionObserver" in window)){
      els.forEach(function(el){ el.classList.add("is-visible"); });
      return;
    }

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold:0.05, rootMargin:"0px 0px -6% 0px" });

    els.forEach(function(el){ observer.observe(el); });

    /* Red de seguridad: si algo impide que el observer dispare, se revela igualmente */
    window.setTimeout(function(){
      document.querySelectorAll(".reveal:not(.is-visible)").forEach(function(el){
        el.classList.add("is-visible");
      });
    }, 6000);
  }

  /* ---------------------------------------------------------------------- */
  /* Tarjetas de producto: reinicia el scroll del panel de información      */
  /* completa cada vez que el cursor vuelve a entrar en la tarjeta.         */
  /* ---------------------------------------------------------------------- */
  function initProductCardInfo(){
    document.querySelectorAll(".product-card").forEach(function(card){
      var info = card.querySelector(".product-card-info");
      if(!info) return;
      card.addEventListener("mouseleave", function(){
        info.scrollTop = 0;
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Parallax suave (scroll) y flotantes reactivos al cursor                */
  /* ---------------------------------------------------------------------- */
  function initParallax(){
    if(reduceMotion) return;

    var parallaxEls = document.querySelectorAll(".parallax-el");
    if(parallaxEls.length){
      var ticking = false;
      function updateParallax(){
        var vh = window.innerHeight;
        parallaxEls.forEach(function(el){
          var rect = el.getBoundingClientRect();
          var center = rect.top + rect.height / 2;
          var offset = (center - vh / 2) / vh;
          var depth = parseFloat(el.getAttribute("data-parallax")) || 10;
          el.style.transform = "translateY(" + (offset * depth * -1) + "px)";
        });
        ticking = false;
      }
      window.addEventListener("scroll", function(){
        if(!ticking){ window.requestAnimationFrame(updateParallax); ticking = true; }
      }, { passive:true });
      updateParallax();
    }

    var heroVisual = document.getElementById("heroVisual");
    var floatEls = document.querySelectorAll(".float-el");
    if(heroVisual && floatEls.length && window.matchMedia("(hover:hover)").matches){
      var raf = null;
      heroVisual.addEventListener("mousemove", function(e){
        var rect = heroVisual.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        if(raf) window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(function(){
          floatEls.forEach(function(el, i){
            var strength = 14 + i * 6;
            el.style.transform = "translate(" + (x * strength) + "px," + (y * strength) + "px)";
          });
        });
      });
      heroVisual.addEventListener("mouseleave", function(){
        floatEls.forEach(function(el){ el.style.transform = "translate(0,0)"; });
      });
    }
  }

  /* ---------------------------------------------------------------------- */
  /* Rutina Nebai interactiva                                                */
  /* ---------------------------------------------------------------------- */
  function initRoutine(){
    var progress = document.getElementById("routineProgress");
    if(!progress) return;

    var steps = Array.prototype.slice.call(progress.querySelectorAll("[data-step]"));
    if(!steps.length) return;

    var img = document.getElementById("routineImg");
    var badge = document.getElementById("routineBadge");
    var stepNum = document.getElementById("routineStepNum");
    var title = document.getElementById("routineTitle");
    var text = document.getElementById("routineText");
    var benefit = document.getElementById("routineBenefit");
    var cta = document.getElementById("routineCta");
    var prevBtn = document.getElementById("routinePrev");
    var nextBtn = document.getElementById("routineNext");

    var current = 0;

    function render(index){
      var step = steps[index];
      if(!step) return;
      current = index;

      if(img){
        img.style.opacity = "0";
        window.setTimeout(function(){
          img.setAttribute("src", step.getAttribute("data-img"));
          img.setAttribute("alt", step.getAttribute("data-alt") || "");
          img.style.opacity = "1";
        }, reduceMotion ? 0 : 180);
      }
      if(badge) badge.textContent = String(index + 1);
      if(stepNum) stepNum.textContent = String(index + 1);
      if(title) title.textContent = step.getAttribute("data-title") || "";
      if(text) text.textContent = step.getAttribute("data-text") || "";
      if(benefit) benefit.textContent = step.getAttribute("data-benefit") || "";
      if(cta){
        cta.setAttribute("href", step.getAttribute("data-cta-href") || "#");
        cta.textContent = step.getAttribute("data-cta-label") || "Ver producto";
      }
      steps.forEach(function(s, i){
        s.setAttribute("aria-current", i === index ? "true" : "false");
      });
    }

    steps.forEach(function(step, i){
      step.addEventListener("click", function(){ render(i); });
    });
    if(prevBtn) prevBtn.addEventListener("click", function(){
      render((current - 1 + steps.length) % steps.length);
    });
    if(nextBtn) nextBtn.addEventListener("click", function(){
      render((current + 1) % steps.length);
    });

    /* Desplazamiento horizontal (swipe) en el visual de la rutina */
    var visual = document.querySelector(".routine-visual");
    if(visual){
      var touchStartX = null;
      visual.addEventListener("touchstart", function(e){
        touchStartX = e.changedTouches[0].clientX;
      }, { passive:true });
      visual.addEventListener("touchend", function(e){
        if(touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if(Math.abs(dx) > 40){
          if(dx < 0) render((current + 1) % steps.length);
          else render((current - 1 + steps.length) % steps.length);
        }
        touchStartX = null;
      }, { passive:true });
    }

    render(0);

    /* Vuelve a pintar el paso actual cuando cambian los data-* traducidos */
    document.addEventListener("nebai:langchange", function(){ render(current); });
  }

  /* ---------------------------------------------------------------------- */
  /* Ingredientes interactivos                                               */
  /* ---------------------------------------------------------------------- */
  function initIngredients(){
    var cards = document.querySelectorAll("[data-ingredient]");
    if(!cards.length) return;
    cards.forEach(function(card){
      card.addEventListener("click", function(){
        var willOpen = card.getAttribute("aria-expanded") !== "true";
        cards.forEach(function(c){ c.setAttribute("aria-expanded", "false"); });
        card.setAttribute("aria-expanded", willOpen ? "true" : "false");
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* FAQ: acordeón + categorías                                              */
  /* ---------------------------------------------------------------------- */
  function initFAQ(){
    var list = document.getElementById("faqList");
    if(!list) return;

    // El desplegado/plegado de cada respuesta se anima por CSS a partir del
    // atributo aria-expanded (ver .faq-a en styles.css); aquí solo se
    // alterna el estado.
    list.querySelectorAll(".faq-q").forEach(function(btn){
      btn.addEventListener("click", function(){
        var open = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", open ? "false" : "true");
        btn.closest(".faq-item").setAttribute("aria-expanded", open ? "false" : "true");
      });
    });

    var items = document.getElementById("faqItems");
    var tabs = document.querySelectorAll(".faq-tab");
    var FILTER_FADE_MS = 220; // debe coincidir con la transición de .faq-items en styles.css

    tabs.forEach(function(tab){
      tab.addEventListener("click", function(){
        if(tab.getAttribute("aria-selected") === "true") return;

        tabs.forEach(function(t){ t.setAttribute("aria-selected", "false"); });
        tab.setAttribute("aria-selected", "true");
        var cat = tab.getAttribute("data-category");

        var applyFilter = function(){
          list.querySelectorAll(".faq-item").forEach(function(item){
            var show = cat === "todas" || item.getAttribute("data-category") === cat;
            item.hidden = !show;
          });
        };

        if(!items){ applyFilter(); return; }

        items.classList.add("is-switching");
        window.setTimeout(function(){
          applyFilter();
          // Forzar reflow para que la transición de entrada vuelva a disparar.
          void items.offsetWidth;
          items.classList.remove("is-switching");
        }, FILTER_FADE_MS);
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Página de producto: galería y pestañas                                  */
  /* ---------------------------------------------------------------------- */
  function initProductGallery(){
    var thumbs = document.querySelectorAll("[data-thumb]");
    var main = document.getElementById("galleryMain");
    if(!thumbs.length || !main) return;
    thumbs.forEach(function(thumb){
      thumb.addEventListener("click", function(){
        thumbs.forEach(function(t){ t.setAttribute("aria-current", "false"); });
        thumb.setAttribute("aria-current", "true");
        main.setAttribute("src", thumb.getAttribute("data-full"));
        main.setAttribute("alt", thumb.getAttribute("data-alt") || "");
      });
    });
  }

  function initProductTabs(){
    var tabs = document.querySelectorAll(".pdp-tab");
    if(!tabs.length) return;
    tabs.forEach(function(tab){
      tab.addEventListener("click", function(){
        tabs.forEach(function(t){ t.setAttribute("aria-selected", "false"); });
        tab.setAttribute("aria-selected", "true");
        var target = tab.getAttribute("data-tab-target");
        document.querySelectorAll(".pdp-tab-panel").forEach(function(panel){
          panel.hidden = panel.id !== target;
        });
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Init                                                                     */
  /* ---------------------------------------------------------------------- */
  function init(){
    if(window.__nebaiMainInit__) return;
    window.__nebaiMainInit__ = true;
    safe(initThemeToggle, "modo oscuro");
    safe(initHeader, "header");
    safe(initMobileMenu, "menú móvil");
    safe(initSearch, "búsqueda");
    safe(initReveal, "reveal");
    safe(initProductCardInfo, "info de producto");
    safe(initParallax, "parallax");
    safe(initRoutine, "rutina");
    safe(initIngredients, "ingredientes");
    safe(initFAQ, "faq");
    safe(initProductGallery, "galería producto");
    safe(initProductTabs, "pestañas producto");
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  }else{
    init();
  }
})();
